export default __webpack_public_path__ + "static/4-df7e935ee4aa3ac09126592b431d8263.png";